import type { ThinkingTraceEntry } from '../types/playground';

/**
 * Andamento ao vivo de uma tool longa no trace (AB#86888) — a await_task esperando uma
 * execução. O texto fica na entrada da tool enquanto ela roda e sai quando o turno termina.
 */

/** O trace com `progress` na tool `toolCallId`; as demais entradas ficam como estão. */
export function applyToolProgress(
  trace: ThinkingTraceEntry[],
  toolCallId: string,
  progress: string,
): ThinkingTraceEntry[] {
  return trace.map(entry =>
    entry.kind === 'tool' && entry.toolCallId === toolCallId ? { ...entry, progress } : entry,
  );
}

/** O trace sem o andamento ao vivo, para guardar na timeline ao fim do turno. */
export function stripToolProgress(trace: ThinkingTraceEntry[]): ThinkingTraceEntry[] {
  return trace.map(entry => {
    if (entry.kind !== 'tool' || entry.progress === undefined) return entry;
    const { progress: _progress, ...rest } = entry;
    return rest;
  });
}
